import { useSelector } from "react-redux"
import { getParentCompanyOrCompanyName } from "reducers/companyInfo"
import { Spacer } from "../atoms/Atoms"
import React from "react"
import L10n from "../../../lib/carrot-l10n"
import { HomeCard } from "./Home"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const HowToUseYourBenefitCard = () => {
  const companyName = useSelector(getParentCompanyOrCompanyName)

  return (
    <HomeCard halfWidth>
      <H2>{l`client.home.howToUse`}</H2>
      <Spacer height={0.25} />
      <span className="publico-text fw4 lh-copy black-80">
        {l("client.home.hasPartneredWithCarrot", { companyName })}
      </span>
      <Spacer height={1} />
      <ArrowLink to="/your-benefit-guide/about-your-benefit">{l`client.about.aboutYourBenefit`}</ArrowLink>
    </HomeCard>
  )
}

export default HowToUseYourBenefitCard
